import type { RiskLevel } from '../hooks/useEmployerHealth';

/** Chakra color tokens for risk indicators (use with `color` prop) */
export const RISK_COLORS: Record<RiskLevel, string> = {
  low: 'green.500',
  medium: 'orange.500',
  high: 'red.500',
};

/** Raw hex values matching RISK_COLORS (use where Chakra tokens aren't supported) */
export const RISK_COLORS_HEX: Record<RiskLevel, string> = {
  low: '#38A169',
  medium: '#DD6B20',
  high: '#E53E3E',
};

/** Chakra colorScheme names for risk badges (use with `colorScheme` prop) */
export const RISK_COLOR_SCHEMES: Record<RiskLevel, string> = {
  low: 'green',
  medium: 'yellow',
  high: 'red',
};

/** Chakra background tokens for risk-colored containers */
export const RISK_BG: Record<RiskLevel, string> = {
  low: 'green.50',
  medium: 'orange.50',
  high: 'red.50',
};

/** Chakra border tokens for risk-colored containers */
export const RISK_BORDER: Record<RiskLevel, string> = {
  low: 'green.200',
  medium: 'orange.200',
  high: 'red.200',
};

export const TREND_COLORS: Record<string, string> = {
  growing: 'green.500',
  stable: 'gray.500',
  declining: 'red.500',
};
